import { createSlice } from "@reduxjs/toolkit";
import services from "../services";

interface ListPostsState {
    data: any[];
    loading: boolean;
    error: boolean;
}

const initialState: ListPostsState = {
    data: [],
    loading: false,
    error: false,
};

const listPostsSlice = createSlice({
    name: "listPosts",
    initialState,
    reducers: {
        getListPosts: (state) => {
            state.loading = true;
            state.error = false;
            state.data = [];
        },
        getListPostsSuccess: (state, actions) => {
            state.loading = false;
            state.error = false;
            state.data = actions.payload;
        },
        getListPostsFailure: (state) => {
            state.loading = false;
            state.error = true;
            state.data = [];
        },
    },
});

export const { getListPosts, getListPostsSuccess, getListPostsFailure } =
    listPostsSlice.actions;

export default listPostsSlice.reducer;

export const fetchListPosts =
    (page: string, auth: boolean) =>
        async (
            dispatch: (arg0: {
                payload: any;
                type:
                    | "listPosts/getListPosts"
                    | "listPosts/getListPostsSuccess"
                    | "listPosts/getListPostsFailure";
            }) => void
        ) => {
            dispatch(getListPosts());
            try {
                const response = await services.listPosts(page, auth);
                dispatch(getListPostsSuccess(response.data));
            } catch (err) {
                console.log("err: ", err);
                dispatch(getListPostsFailure());
            }
        };
